module.exports = __webpack_public_path__ + "assets/vidjet-logo.220fdb11.svg";